module.exports = __webpack_public_path__ + "img/symbol_7.539646a2.png";